import Vue from 'vue'
import vuex from 'vuex'

Vue.use(vuex);

import app from './modules/app'
import tab from './modules/tab'
import iframe from './modules/iframe'
import user from './modules/user'
import menu from './modules/menu'
import titleSwitch from './modules/titleSwitch'
import village from './modules/village'
import organize from './modules/organize';
const store = new vuex.Store({
  modules: {
    app: app,
    tab: tab,
    iframe: iframe,
    user: user,
    menu: menu,
    title: titleSwitch,
    village: village,
    organize:organize,
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js